import React from "react";
import { Link } from "react-router-dom";
import { Tooltip } from "antd";

const PartnerLink = ({ partner, showType = false }) => {
  const fullNameOrCompany = partner?.first_name || partner?.last_name
    ? `${partner?.first_name} ${partner?.last_name}`
    : partner?.company_name;

  // Determine partner type:
  // ŽL = contractor (has contract_signed AND company_number)
  // SP = worker (has contract_signed BUT no company_number)
  // If no contract_signed, don't show type
  let displayText = fullNameOrCompany;
  
  if (showType && partner?.contract_signed) {
    const typeLabel = partner?.company_number ? 'ŽL' : 'SP';
    displayText = `${fullNameOrCompany} - ${typeLabel}`;
  }

  return (
    <Tooltip title={displayText}>
      <Link to={"/partners/" + partner?.id} style={{ borderBottom: "1px dotted" }} target="_blank">
        {displayText}
      </Link>
    </Tooltip>
  );
};

export default PartnerLink;
